/**
 * 节点工具栏组件
 *
 * 左侧工具栏，显示所有可拖拽的节点类型
 */

import { type DragEvent } from 'react';
import { nodeTypeNames, nodeTypeIcons, nodeTypeColors } from './nodes';
import type { WorkflowNodeType } from '../../types/workflow';

// 可用的节点类型列表（按常用程度排序）
const availableNodeTypes: WorkflowNodeType[] = [
  'start',
  'agent',
  'loop',
  'condition',
  'info',
  'note',
];

/**
 * 节点工具栏组件
 */
export function NodeToolbar() {
  // 处理拖拽开始
  const onDragStart = (
    event: DragEvent<HTMLDivElement>,
    nodeType: WorkflowNodeType
  ) => {
    // 设置拖拽数据
    event.dataTransfer.setData('application/reactflow', nodeType);
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
      {/* 标题 */}
      <div className="px-3 py-2 bg-gray-50 border-b border-gray-200">
        <h3 className="text-sm font-medium text-gray-700">节点类型</h3>
      </div>

      {/* 节点列表 */}
      <div className="p-2 space-y-1">
        {availableNodeTypes.map((type) => {
          const colors = nodeTypeColors[type] || nodeTypeColors.agent;
          const icon = nodeTypeIcons[type];
          const name = nodeTypeNames[type] || type;

          return (
            <div
              key={type}
              draggable
              onDragStart={(e) => onDragStart(e, type)}
              className={`
                flex items-center gap-2 px-3 py-2 rounded-md cursor-grab
                transition-colors duration-150
                hover:bg-gray-100 active:cursor-grabbing
                ${colors.bg} ${colors.text} border ${colors.border}
              `}
            >
              {/* 图标 */}
              <span className="flex-shrink-0 opacity-80">{icon}</span>

              {/* 名称 */}
              <span className="text-sm font-medium">{name}</span>

              {/* 拖拽提示 */}
              <svg
                className="w-4 h-4 ml-auto opacity-40"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 8h16M4 16h16"
                />
              </svg>
            </div>
          );
        })}
      </div>

      {/* 提示信息 */}
      <div className="px-3 py-2 bg-gray-50 border-t border-gray-200">
        <p className="text-xs text-gray-500">
          拖拽节点到画布上创建
        </p>
      </div>
    </div>
  );
}

export default NodeToolbar;
